var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3519 7.78001C20.0129 7.78001 19.6879 7.91466 19.4482 8.15433L8.22434 19.3782C7.22615 20.3764 7.22615 21.9948 8.22434 22.993L16.984 31.7526C17.9821 32.7508 19.6005 32.7508 20.5987 31.7526L31.8226 20.5287C32.0622 20.289 32.1969 19.964 32.1969 19.625L32.1969 10.3718C32.1969 10.0328 32.0623 9.70776 31.8226 9.46808L30.5088 8.15433C30.2691 7.91466 29.9441 7.78001 29.6051 7.78001L20.3519 7.78001ZM24.9784 14.9988C25.8326 15.8531 27.2177 15.8531 28.0719 14.9988C28.9262 14.1445 28.9262 12.7595 28.0719 11.9052C27.2177 11.0509 25.8326 11.0509 24.9784 11.9052C24.1241 12.7595 24.1241 14.1445 24.9784 14.9988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tagIcon.7f25ca1d57dc1792c79a9fafebbbab8f.svg";
export { ForwardRef as ReactComponent };